import React, { useState, useEffect } from 'react';
import { Download, FileText, Calendar } from 'lucide-react';

const ReportesEstudiante = () => {
  const [reportes, setReportes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadReportes();
  }, []);

  const loadReportes = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1'}/estudiante/reportes`);
      const data = await response.json();
      setReportes(data.reportes || []);
    } catch (error) {
      console.error('Error loading reportes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (reporte) => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';
      const response = await fetch(`${API_URL}/estudiante/reportes/download/${reporte.id_reporte}`);
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        alert(err.message || 'Error al descargar');
        return;
      }
      const arrayBuffer = await response.arrayBuffer();
      const contentType = response.headers.get('content-type') || 'application/octet-stream';
      const blob = new Blob([arrayBuffer], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      // Get filename from Content-Disposition header or fallback to reporte title
      const disposition = response.headers.get('content-disposition');
      let fileName = `${reporte.titulo || 'documento'}`;
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match) fileName = match[1];
      }
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading reporte:', error);
      alert('Error al descargar el reporte');
    }
  };

  return (
    <div className="p-6 md:p-6 space-y-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-xl font-bold text-gray-800">Estudiante &gt; Comunicados</h1>
      </div>

      {/* Lista de Reportes */}
      {loading ? (
        <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">
          Cargando reportes...
        </div>
      ) : reportes.length === 0 ? (
        <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">
          No hay reportes disponibles en este momento
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reportes.map(reporte => (
            <div key={reporte.id_reporte} className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow">
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <FileText size={40} className="text-blue-900" />
                  <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                    {reporte.tipo_reporte || 'General'}
                  </span>
                </div>

                <h3 className="text-lg font-semibold text-gray-800 mb-2">{reporte.titulo}</h3>
                <p className="text-sm text-gray-600 mb-4 line-clamp-3">{reporte.descripcion}</p>

                <div className="flex items-center text-xs text-gray-500 mb-4">
                  <Calendar size={14} className="mr-1" />
                  <span>
                    {reporte.fecha_publicacion
                      ? new Date(reporte.fecha_publicacion).toLocaleDateString()
                      : 'Fecha no disponible'}
                  </span>
                </div>

                <button
                  onClick={() => handleDownload(reporte)}
                  className="w-full px-4 py-2 bg-blue-900 text-white rounded-lg hover:bg-blue-800 flex items-center justify-center space-x-2"
                >
                  <Download size={18} />
                  <span>Descargar aquí</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Info adicional */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          <strong>Nota:</strong> Los documentos son cargados por el área de Jefatura de Carrera.
          Si no encuentras el documento que buscas, contacta directamente con la jefatura.
        </p>
      </div>
    </div>
  );
};

export default ReportesEstudiante;